import { API_PATHS } from "../constants/api-paths";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { type IResponse, encryptedRequest } from "../core/api.client";

// Local type - not exported to avoid naming conflicts
type IApiResponseDemog = {
  custType: string;
  city: string;
  firstName: string;
  lastName: string;
  gender: string;
  employmentType: string;
  annualIncome: string;
  custId: string;
  addressLine1: string;
  addressLine2: string;
  addressType: string;
  stateName: string;
  pinCode: string;
  reKycFlag: string;
  kycRenewalDate: string;
  multipleCustIds?: {
    city: string;
    custId: string;
    addressLine1: string;
    addressLine2: string;
    pinCode: string;
    firstName: string;
    lastName: string;
    indivCorpFlag: string;
    dob: string;
    panNo: string;
    gstNumber: string;
  }[];
  indivCorpFlag: string;
  panNo: string;
  dob: string;
  gstnNumber: string;
  email: string;
  rekycflag?: string;
  kycProcess?: string;
};

export type IApiRequest = {
  mobileNo: string;
  custId?: string;
};

const getUserDetailsApi = async (
  mobileNo: string,
  custId?: string
): Promise<IResponse<IApiResponseDemog>> => {
  if (globalThis.window.location.href.includes("initiate-tarsier-webview")) {
    return {
      data: {} as IApiResponseDemog,
      statusCode: 90,
      status: "success",
      message: "Mocked response for initiate-tarsier-webview",
    };
  }
  const response = await encryptedRequest<IApiResponseDemog, IApiRequest>({
    method: "POST",
    url: API_PATHS.userDetails,
    data: {
      mobileNo,
      custId,
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const getUserDetails = async (
  mobileNo: string,
  custId?: string
): Promise<IResponse<IApiResponseDemog>> => {
  const response = await createCacheAsync(
    `${API_PATHS.userDetails}-${mobileNo}-${custId}`,
    getUserDetailsApi,
    mobileNo,
    custId
  );
  return response;
};

// Alias: identical to getUserDetails – kept for backwards compatibility.
export const getUserDetailsWithoutWrapper = getUserDetails;
